import { createFileRoute } from '@tanstack/react-router'
import { FnsDetailPage } from '@/features/forms-and-surveys/pages'

export const Route = createFileRoute('/_authenticated/forms/$formId/')({
  component: FnsDetailPage,
})
